import { wsCall, requestHelper } from "../../../app/coreSlice";

const carclubGetDefaultConfigsCall = async ({ setCarclubDefaultConfigs }, dispatch, state) => {
  const selectedLocation = state?.getIn(["carclub2"])?.defaultLocation;
  let rh = requestHelper(dispatch, "CARCLUB/GET_DEFAULT_CONFIGS");
  let result;
  try {
    result = await wsCall({
      type: "CARCLUB",
      subType: "GET_DEFAULT_CONFIGS",
      locationId: selectedLocation?.id,
    });

    if (!result.error) {
      dispatch(setCarclubDefaultConfigs(result));
    } else {
      rh.error(result?.description || "Error loading carclub default configs.");
    }
  } catch (_ex) {
    rh.error("Error loading carclub default configs.");
  }
  rh.close();
  return result;
};

export default carclubGetDefaultConfigsCall;
